export default __webpack_public_path__ + "static/landing-background-4304980834b86016ab4e06662b21d361.png";